import { connect } from 'react-redux';
import { StoreState } from '../../../reducers';
import { MultiAppAuthenticationViewMode } from '../constants';
import AuthUtils from '../../../utils/authentication';
import { InputName, MultiAppAuthenticationForm } from '../../../components/MultiAppAuthentication/Form';
import { MultiAppAuthenticationCredentials, MultiAppAuthenticationFormState } from '../reducer';

interface MultiAppAuthenticationFormOwnProps {
	viewMode: MultiAppAuthenticationViewMode;
}

const mapStateToProps = (state: StoreState, ownProps: MultiAppAuthenticationFormOwnProps) => {
	const { multiAppAuthenticationInfos, appInfos, galleryInfos: { config } } = state;
	const { form, aspConnexionStatus, credentials } = multiAppAuthenticationInfos;
	// userLocale is sent as a prop, to allow the rerendering of placeholders when the language is switched
	const { userLocale } = appInfos;

	const isLoginView = AuthUtils.isLoginView(ownProps.viewMode);
	const isPasswordView = AuthUtils.isPasswordView(ownProps.viewMode);
	const isCompanyView = AuthUtils.isCompanyView(ownProps.viewMode);
	const isCreationView = AuthUtils.isCreationView(ownProps.viewMode);

	const login = getFieldValue(InputName.Login, form, credentials);
	const password = getFieldValue(InputName.Password, form, credentials);
	return {
		form: { ...form, login, password },
		aspConnexionStatus,
		userLocale,
		isLoginView,
		isPasswordView,
		isCompanyView,
		isCreationView,
		galleryConfig: config
	};
};

const getFieldValue = (
	inputName: InputName,
	form: MultiAppAuthenticationFormState,
	credentials: MultiAppAuthenticationCredentials | undefined
) => {
	if (form[inputName]) {
		return form[inputName];
	}

	if (credentials && credentials[inputName]) {
		return credentials[inputName];
	}

	return '';
};

export default connect(mapStateToProps)(MultiAppAuthenticationForm);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/MultiAppAuthentication/Form/index.tsx